import { TabProps } from '@silverfort/sf-components/dist/Tabs/Tab';

export enum ApplicationDetailsTab {
    Resources = 'Resources',
    Users = 'Users'
}

export const ApplicationDetailsTabs: Array<TabProps<ApplicationDetailsTab>> = [
    {
        name: 'Users',
        value: ApplicationDetailsTab.Users
    },
    {
        name: 'Resources',
        value: ApplicationDetailsTab.Resources
    }
];
